import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ticketApi } from '../api/tickets';

/**
 * Deep-link resolver: /t/:ticketId fetches ticket to learn its machineId,
 * then redirects to /machines/{machineId}?tab=tickets&ticketId={id}.
 */
const TicketResolver: React.FC = () => {
  const { ticketId } = useParams<{ ticketId: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!ticketId) {
      setError('Brak identyfikatora zgłoszenia');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const { data } = await ticketApi.get(ticketId);
        if (cancelled) return;
        navigate(`/machines/${data.ticket.machineId}?tab=tickets&ticketId=${ticketId}`, { replace: true });
      } catch (e: any) {
        if (cancelled) return;
        const status = e?.response?.status;
        if (status === 401 || status === 403) {
          navigate(`/login?next=/t/${ticketId}`, { replace: true });
        } else {
          setError('Zgłoszenie nie istnieje lub nie masz do niego dostępu');
        }
      }
    })();
    return () => { cancelled = true; };
  }, [ticketId, navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--color-text-muted)' }}>
      {error ?? 'Otwieranie zgłoszenia…'}
    </div>
  );
};

export default TicketResolver;
